import { inject, injectWithTransform, singleton } from "tsyringe";
import { Logger, LoggerTransformer } from "./logger";
import { HttpClient, HttpError } from "./http-client";
import { COOKIES } from "@identity/symbols";
import { Geo } from "./geo";
import { ServiceBaseUrl } from "./service-base-url";

class GeoCookieException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "GeoCookieException";
  }
}

@singleton()
export class GeoCookie {
  private geoIPUrl = this.serviceBaseUrl.get() + "geoip/location";

  constructor(
    @inject(COOKIES) private readonly cookiesManager: CookiesManager,
    @inject(HttpClient) private readonly httpClient: HttpClient,
    @injectWithTransform(Logger, LoggerTransformer, "GeoCookie")
    private readonly logger: Logger,
    @inject(Geo) private geo: Geo,
    @inject(ServiceBaseUrl) private serviceBaseUrl: ServiceBaseUrl,
  ) {}

  async setGeoCookieIfNotExist(): Promise<void> {
    if (this.cookiesManager.get("Geo")) {
      this.logger.info("Geo cookie already exists");
      return;
    }
    try {
      const response = await this.httpClient.get(this.geoIPUrl);
      const { country_code, region, continent_code } = await response.json();
      const geoData = {
        country: country_code,
        region,
        continent: continent_code,
      };
      const geoCookie = JSON.stringify(geoData);

      this.cookiesManager.set("Geo", geoCookie, { expires: 365 });
      this.geo.set(geoData);

      this.logger.info("Geo cookie set");
    } catch (e) {
      if (e instanceof HttpError) {
        throw new GeoCookieException(
          `Failed to fetch Geo cookie from pandora: ${e}`,
        );
      }
      throw new GeoCookieException(`Failed to set Geo cookie: ${e}`);
    }
  }
}
